/** Customer interest tags (SPEC §7/§8). Mirrors backend src/lib/interestTags.ts.
 * Keep in sync — the backend validates the key on write. */
export interface InterestTag {
  key: string;
  label: string;
}

export const INTEREST_TAGS: InterestTag[] = [
  { key: 'fine_wine', label: 'Fine Wine' },
  { key: 'en_primeur', label: 'En Primeur' },
  { key: 'corporate_christmas', label: 'Corporate Christmas' },
  { key: 'whiskey_special_releases', label: 'Whiskey Special Releases' },
  { key: 'midleton_very_rare', label: 'Midleton Very Rare' },
];
